import { useState } from 'react';
import { ActiveFilters, getFilteredData, IFilter, ACTIVE_FILTER_DELIMITER } from '../filter';
import { ActiveSorter } from '../sort';

export type FiltersAndSortProps<T> = {
  data: T[];
  filters: IFilter<T>[];
  sorters?: ActiveSorter<T>[];
  initialFilters?: ActiveFilters;
  initialSorter?: ActiveSorter<T>;
};

export function useFiltersAndSort<T>({ data = [], filters = [], initialFilters = new Set() }: FiltersAndSortProps<T>) {
  const [activeFilters, setActiveFilters] = useState(initialFilters);
  const [activeSorter, setActiveSorter] = useState<ActiveSorter<T>>(undefined);
  const filteredData = getFilteredData(data, filters, activeFilters);
  const addFilter = (filterIdentifier: string) => {
    const filterGroup = filterIdentifier.split(ACTIVE_FILTER_DELIMITER)[0];

    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const filterGroupData = filters.find((f) => f.groupName === filterGroup)!;
    const newActiveFilterState = new Set(activeFilters);
    activeFilters.forEach((f) => {
      if (f.split(ACTIVE_FILTER_DELIMITER)[0] === filterGroup) {
        if (!filterGroupData.allowedMultipleFilters) {
          newActiveFilterState.delete(f);
        }
      }
    });

    newActiveFilterState.add(filterIdentifier);
    setActiveFilters(newActiveFilterState);
  };

  const removeFilter = (filterIdentifier: string) => {
    const newActiveFilterState = new Set(activeFilters);
    newActiveFilterState.delete(filterIdentifier);
    setActiveFilters(newActiveFilterState);
  };

  const clearAllFilters = () => {
    setActiveFilters(new Set());
  };

  const toggleFilter = (filterIdentifier: string) => {
    if (!activeFilters.has(filterIdentifier)) {
      addFilter(filterIdentifier);
    } else {
      removeFilter(filterIdentifier);
    }
  };
  return {
    activeFilters,
    // setActiveFilters,
    toggleFilter,
    clearAllFilters,
    filteredData,
    filters,
    addFilter,
    removeFilter,
    activeSorter,
    setActiveSorter,
  };
}
